import { render, staticRenderFns } from "./tiptap.vue?vue&type=template&id=56d6d404&scoped=true&"
import script from "./tiptap.vue?vue&type=script&lang=js&"
export * from "./tiptap.vue?vue&type=script&lang=js&"
import style0 from "./tiptap.vue?vue&type=style&index=0&id=56d6d404&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6d404",
  null
  
)

export default component.exports